<template>
    <div>
        <order-item
            v-for="(order, index) in orders"
            :key="index"
            :order="order">
        </order-item>
        <button
            v-if="canFetchMoreOrders"
            @click="fetchNextPage"
            class="btn btn--secondary mt-4">
            {{ $t('ORDERS_LIST_LOAD_MORE') }}
        </button>
    </div>
</template>

<script>
import OrderItem from '@/components/partials/account/manage-account/OrderItem';

export default {
    name: 'OrdersList',
    mounted() {
        this.$store.dispatch('order/fetchOrders');
    },
    computed: {
        canFetchMoreOrders() {
            return this.$store.getters['order/canFetchMoreOrders'];
        },
        currentOrdersPage() {
            return this.$store.getters['order/currentOrdersPage'];
        },
        orders() {
            return this.$store.getters['order/getAllOrders'];
        },
    },
    methods: {
        fetchNextPage() {
            this.$store.dispatch('order/fetchOrders', this.currentOrdersPage + 1);
        },
    },
    components: {
        OrderItem,
    },
};
</script>
